/// <amd-module name="Test/TestCaseResults/Redux/TestCaseResultsFilterReducer" />
import produce from "immer";

import { TestCaseResultsActions, TestCaseResultsActionsTypes } from "./TestCaseResultsActions";
import { ITestCaseResultsFilterState } from "./TestCaseResultsContracts";

export function TestCaseResultsFilterReducer(state: ITestCaseResultsFilterState, action: TestCaseResultsActions): ITestCaseResultsFilterState {
    state = state || ({} as ITestCaseResultsFilterState);

    return produce(state, (draftState: ITestCaseResultsFilterState) => {
        switch (action.type) {
            case TestCaseResultsActionsTypes.updateFilteredResults:
                draftState.filteredResultIds = action.payload.filteredResults;
                break;

            default:
                break;
        }
    });
}
